import { render, staticRenderFns } from "./WithdrawInfo.vue?vue&type=template&id=16673794&scoped=true&"
import script from "./WithdrawInfo.vue?vue&type=script&lang=js&"
export * from "./WithdrawInfo.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawInfo.vue?vue&type=style&index=0&id=16673794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16673794",
  null
  
)

export default component.exports